'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$56() {
  this.aGC = null;
  this.aGA = null;
  this.aGB = false;
  this.aGy = null;
  this.aGz = false;
  this.aGD = false;
  this.aGE = false;
  this.aGC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$56 as $c_Lpresto_CredentialsView$$anon$56 };
$p = $c_Lpresto_CredentialsView$$anon$56.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$56;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$56() {
}
export { $h_Lpresto_CredentialsView$$anon$56 as $h_Lpresto_CredentialsView$$anon$56 };
$h_Lpresto_CredentialsView$$anon$56.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aGC;
});
$p.t = (function() {
  if ((!this.aGB)) {
    this.aGA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGB = true;
  }
  return this.aGA;
});
$p.ae = (function() {
  if ((!this.aGz)) {
    this.aGy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().v9(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGz = true;
  }
  return this.aGy;
});
$p.w = (function() {
  if ((!this.aGE)) {
    this.aGD = false;
    this.aGE = true;
  }
  return this.aGD;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$56 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$56, "presto.CredentialsView$$anon$56", ({
  FZ: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$56 as $d_Lpresto_CredentialsView$$anon$56 };
//# sourceMappingURL=presto.-Credentials-View$$anon$56.js.map
